<div class="container text-center">
  <h2>Page introuvable</h2>
  <p>Désolé, cette page a peut-être été supprimée ou déplacée. <br/> Pour retrouver votre chemin :</p>
  <button class="btn-dark btn" [routerLink]="'/'">Page d'accueil</button>
</div>
